import React from 'react';
import styled from 'styled-components';
import { Field, FieldRenderProps } from 'react-final-form';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Typography } from '../Typography';
import { InfoTooltip } from "../Tooltip/InfoTooltip";

interface FormInputProps {
  id?: string;
  name: string;
  label?: string;
  placeholder?: string;
  tooltip?: React.ReactNode;
  initialValue?: string | undefined ;
  multiline?: boolean;
  required?:boolean
}

interface StyledProps {
  $hasText?: boolean;
}

export const FormInput: React.FC<FormInputProps> = ({
  id,
  name,
  label,
  placeholder,
  tooltip,
  initialValue,
  multiline = false,
  required=false
}) => {
  return (
    <Field<string>
      name={name}
      initialValue={initialValue}
      render={({ input }: FieldRenderProps<string>) => {
        const hasText = !!input.value?.trim();

        return (
          <Container id={id}>
            <Label>
              <Typography variant="body6">
                <label htmlFor={name}>{label} {required && <span style={{color:'#6777FF'}}>*</span>}</label>
              </Typography>
              {tooltip && <InfoTooltip name={`input-tooltip-${name}`} tooltip={tooltip} />}
            </Label>

            {multiline ? (
              <StyledInputTextarea
                {...input}
                id={name}
                placeholder={placeholder}
                rows={5}
                autoResize
                $hasText={hasText}
              />
            ) : (
              <StyledInputText
                {...input}
                id={name}
                placeholder={placeholder}
                $hasText={hasText}
              />
            )}
          </Container>
        );
      }}
    />
  );
};

const Container = styled.div`
  width:100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledInputText = styled(InputText)<StyledProps>`
  border-radius: 10px;
  border: 1px solid ${({ $hasText }) => ($hasText ? '#000000' : '#ced4da')};
  padding: 12px 13px 13px 13px;
  transition: border-color 0.2s ease;
`;

const StyledInputTextarea = styled(InputTextarea)<StyledProps>`
  border-radius: 10px;
  border: 1px solid ${({ $hasText }) => ($hasText ? '#000000' : '#ced4da')};
  padding: 12px 13px 13px 13px;
  transition: border-color 0.2s ease;
`;

const Label = styled.div`
  display: flex;
  gap: 4px;
`;
